var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();
      this.duration = 100;
      this.resizeDebounceTimer = null;
      this._initialized = false;
    }
    
    connectedCallback() {
      // 이미 초기화되었으면 스킵 (퀵뷰에서 재사용 시)
      if (this._initialized) return;
      
      // DOM이 완전히 로드된 후 초기화
      requestAnimationFrame(() => {
        this.initializeGallery();
      });
    }
    
    // 갤러리 초기화 (외부에서도 호출 가능)
    initializeGallery() {
      // DOM 요소 캐싱
      this.thumbItems = this.querySelectorAll('.swiper-thumb');
      this.horizontalContainer = this.querySelector('.swiper-thumb__container--horizontal');
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      
      if (!this.swiper) return;
      
      // 기존 이벤트 리스너 제거 (재초기화 시)
      this.thumbItems.forEach((item) => {
        item.removeEventListener("click", this._boundClickHandler);
      });
      
      // 이벤트 리스너 설정
      this._boundClickHandler = this.clickHandler.bind(this);
      this.thumbItems.forEach((item) => {
        item.addEventListener("click", this._boundClickHandler);
      });
      
      if(this.isTouchDevice()===false && this.horizontalContainer) {
        var _this = this;
        this.horizontalContainer.addEventListener("mouseenter", function(){
          if(window.innerWidth <= 1024) return false;
          if(_this.horizontalContainer.scrollWidth <= _this.offsetWidth) return false;
          document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
          document.body.classList.add('overflow-hidden');
        });
        this.horizontalContainer.addEventListener("mouseleave", function(){
          if(window.innerWidth <= 1024) return false;
          if(_this.horizontalContainer.scrollWidth <= _this.offsetWidth) return false;
          document.body.classList.remove('overflow-hidden');
          document.body.style.paddingRight = '';
        });
      }
      
      // swiper 이벤트 리스너 (중복 방지)
      this.swiper.removeEventListener('slide_inited', this._boundSlideInited);
      this.swiper.removeEventListener('slide_changed_custom', this._boundSlideChanged);
      
      this._boundSlideInited = this.slideInitedCustom.bind(this);
      this._boundSlideChanged = this.slideChangedCustom.bind(this);
      
      this.swiper.addEventListener('slide_inited', this._boundSlideInited, false);
      this.swiper.addEventListener('slide_changed_custom', this._boundSlideChanged, false);

      this.closest('.product--thumbnail_slider__mobile') && this.mobileThumbSize();
      
      this._initialized = true;
      
      // 초기화 완료 클래스 추가
      this.classList.add('gallery-initialized');
    }
    
    // 재초기화 메서드 (퀵뷰용)
    reinitialize() {
      this._initialized = false;
      this.initializeGallery();
      
      // swiper가 초기화된 후 슬라이드 설정
      const swiperEl = this.querySelector('swiper-slider');
      if (swiperEl && swiperEl.swiper) {
        this.slideInitedCustom();
      }
    }
    
    isTouchDevice(){
      return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }
    mobileThumbSize(){
      if(window.innerWidth > 576 || !this.swiperthumbcontainer) return false;
      // bind() 는 매번 새 함수를 만든다 — 한 번만 만들어 보관해야 재초기화(reinitialize) 때
      // 리스너가 쌓이지 않고 disconnectedCallback 에서 제거도 가능하다.
      if(!this._boundResizeHandler){
        this._boundResizeHandler = this.debouncedResizeHandler.bind(this);
      }
      window.removeEventListener("resize", this._boundResizeHandler, false);
      window.addEventListener("resize", this._boundResizeHandler, false);
      this.resizeHandler();
    }
    disconnectedCallback(){
      if(this._boundResizeHandler){
        window.removeEventListener("resize", this._boundResizeHandler, false);
      }
      clearTimeout(this.resizeDebounceTimer);
    }
    debouncedResizeHandler(){
      // resize 이벤트 디바운스 (150ms)
      clearTimeout(this.resizeDebounceTimer);
      this.resizeDebounceTimer = setTimeout(() => {
        this.resizeHandler();
      }, 150);
    }
    resizeHandler(){
      if(!this.swiperthumbcontainer) return false;
      var w = this.swiperthumbcontainer.offsetWidth,
          item_w = (this.swiperthumbcontainer.offsetWidth - 10 * 4)/5;
      this.swiperthumbcontainer.style.setProperty('--thumb-width', `${item_w}px`);
    }
    slideInitedCustom(){
      var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
      if(sect.querySelector('select-option-js.active')){
        return false;
      }
      var default_media_id = this.getAttribute('data-current-media-id');
      this.changeSlideSwiper(default_media_id, 0);
      // 썸네일 하이라이트는 slide_changed_custom 경유로만 갱신되는데, delay 0 이동에서는
      // 그 이벤트가 오지 않을 수 있다. 초기 상태(선택 변형)는 여기서 직접 맞춘다 —
      // 안 그러면 메인은 변형 이미지인데 썸네일만 1번에 남는다(기본 변형 이미지가 갤러리
      // 1번이 아닌 상품이 다변형의 66%, 단일변형의 74%라 눈에 잘 띈다).
      default_media_id && this.syncThumb(default_media_id);
    }
    // 활성 슬라이드는 DOM 클래스가 아니라 swiper 인스턴스에서 얻는다.
    // Swiper 는 slideChange 를 '전환 시작'에 쏘는데 그 시점의 .swiper-slide-active 는
    // 아직 이전 슬라이드다(실측: activeIndex 1 인데 DOM 활성은 4). 클래스를 읽으면
    // 썸네일 하이라이트가 늘 한 칸 뒤처진다.
    activeSlideEl(){
      var sliderEl = this.querySelector('.swiper');
      var sw = sliderEl && sliderEl.swiper;
      if(sw && sw.slides && sw.slides.length){
        var el = sw.slides[sw.activeIndex];
        if(el && el.querySelector) return el;
      }
      return this.querySelector('.swiper-slide-active');
    }
    // 썸네일 컨테이너 방향에 따라 하이라이트+스크롤을 맞춘다(changeSlide 와 같은 판정).
    syncThumb(_id){
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        this.horizontaldesign(_id);
      }
      else{
        this.verticaldesign(_id);
      }
    }
    slideChangedCustom(){
      var activeSlide = this.activeSlideEl();
      if(!activeSlide) return false;

      var mediaElement = activeSlide.querySelector('[data-media-id]');
      if(!mediaElement) return false;

      var _this = this;
      var _id = mediaElement.getAttribute('data-media-id');

      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        setTimeout(function(){
          _this.horizontaldesign(_id);
        },0);
      }
      else{
        setTimeout(function(){
          _this.verticaldesign(_id);
        },0);
      }
      setTimeout(function(){
        _this.playActiveMedia(mediaElement);
      },100);
    }
    clickHandler(e){
      // 활성 썸네일이 없을 수 있다(선택 변형 이미지가 갤러리에 없는 상품). 예전엔 여기서
      // null.classList 로 죽어 썸네일 클릭이 통째로 먹통이 됐다.
      var current = this.querySelector('.swiper-thumb.active') || this.querySelector('.active');
      current && current.classList.remove('active');
      e.currentTarget.classList.add('active');

      var _id = e.currentTarget.getAttribute('data-media-id');
      this.changeSlideSwiper(_id);
    }
    changeSlideSwiper(_id, delay){
      delay = delay === undefined || delay === null ? 300 : delay;
      var swiperslider = this.querySelector('swiper-slider');
      if(!swiperslider) return;

      if(!swiperslider.querySelector(`[data-media-id="${_id}"]`)) return;

      // 대상 슬라이드를 media id 로 찾는다. 첫 매치에서 멈춘다 —
      // 루프 모드에서 같은 media id 가 두 번 잡히면 뒤엣것을 쓰게 되므로.
      var slides = swiperslider.querySelectorAll('.swiper-slide');
      var targetIndex = -1;
      var targetSlide = null;

      for(var i = 0; i < slides.length; i++){
        if(slides[i].querySelector(`[data-media-id="${_id}"]`)){
          targetIndex = i;
          targetSlide = slides[i];
          break;
        }
      }

      if(targetIndex < 0) return;

      var sliderEl = this.querySelector('.swiper');
      if(!sliderEl) return;
      var swiperInstance = sliderEl.swiper;

      // Swiper 11 의 loop 는 슬라이드를 복제하지 않고 DOM 순서를 재배치한다.
      // 그래서 DOM 인덱스로 slideTo 하면 몇 번 넘긴 뒤엔 엉뚱한 슬라이드로 간다.
      // 루프일 때는 Swiper 가 슬라이드에 심어둔 실제 인덱스(data-swiper-slide-index)로
      // slideToLoop 을 써야 한다.
      if(swiperInstance && swiperInstance.params && swiperInstance.params.loop){
        var realIndex = targetSlide.getAttribute('data-swiper-slide-index');
        realIndex = realIndex === null ? targetIndex : parseInt(realIndex, 10);
        if(isNaN(realIndex)) realIndex = targetIndex;
        swiperInstance.slideToLoop(realIndex, delay);
        return;
      }

      sliderEl.selectSlide(targetIndex, delay);
    }
    changeSlide(_id){
      this.syncThumb(_id);
      this.changeSlideSwiper(_id);
    }
    verticaldesign(...args){
      this.scrollToThumb(args[0], 'vertical');
    }
    horizontaldesign(...args){
      this.scrollToThumb(args[0], 'horizontal');
    }
    scrollToThumb(_id, direction){
      if(!this.swiperthumbcontainer) return false;
      
      var item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`);
      if(!item) return false;
      
      // 활성 상태 변경
      var activeItem = this.swiperthumbcontainer.querySelector('.active');
      if(activeItem) activeItem.classList.remove('active');
      item.classList.add('active');
      
      var temp = 0;
      var isVertical = direction === 'vertical';
      var scrollProp = isVertical ? 'scrollTop' : 'scrollLeft';
      var offsetProp = isVertical ? 'offsetTop' : 'offsetLeft';
      var sizeProp = isVertical ? 'offsetHeight' : 'offsetWidth';
      var containerOffsetProp = isVertical ? 'offsetTop' : 'offsetLeft';
      
      var itemOffset = item[offsetProp] - this.swiperthumbcontainer[containerOffsetProp];
      var containerSize = this.swiperthumbcontainer[sizeProp];
      var currentScroll = this.swiperthumbcontainer[scrollProp];
      var itemEnd = itemOffset - currentScroll + item[sizeProp];
      var delta = (!isVertical && window.innerWidth <= 576) ? 15 : 0;
      
      if(itemEnd > containerSize){
        temp = currentScroll + (itemEnd - containerSize) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, scrollProp);
      }
      else if(itemOffset < currentScroll){
        temp = currentScroll - (currentScroll - itemOffset) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, scrollProp);
      }
    }
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('swiper-slider-container', swiperSliderContainer);
}

elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {
  class themeLightbox extends HTMLElement {
    constructor() {
      super();
      var slides = this.querySelectorAll('.swiper-slide'),
          bullets = this.querySelector('.swiper-pagination');
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
      this.querySelector('.theme-lightbox__toggle').addEventListener("click", this.close.bind(this), false);
    }
    resizeHandler(){
      this.querySelectorAll('.theme-lightbox__image').forEach((item) => {
        var ww = window.innerWidth - 218,
            wh = window.innerHeight - 136,
            iw = item.naturalWidth,
            ih = item.naturalHeight,
            wr = ww/iw;
        if(iw > ih ){
          if(ih*wr >= wh){
            item.classList.remove('theme-lightbox__image--wide');
          }
          else{
            item.classList.add('theme-lightbox__image--wide');
          }
        }
      });
    }
    open(data_media_id){
      this.classList.add('active');
      setTimeout(() => {
        this.classList.add('animate');
      });
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');

      
      var item_img = this.querySelector(`[data-media-id="${data_media_id}"]`).closest('.swiper-slide');
      const nodes = Array.prototype.slice.call( item_img.parentNode.childNodes );
      const index = nodes.indexOf(item_img);
      this.querySelector('.swiper').selectSlide(index);
    }
    close() {
      this.classList.remove('animate');
      setTimeout(() => {
        this.classList.remove('active');
      }, 500);
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
      window.pauseAllMedia();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('theme-lightbox', themeLightbox);
}

elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
    }
    clickHandler(e){
      var id = this.getAttribute('data-id'),
          item = document.getElementById(id),
          data_media_id = this.getAttribute('data-media-id');
      item.open(data_media_id);
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}
// ADDTOCART 버튼 호버 효과
elementName = "addtocart-hover-lift";
if (!customElements.get(elementName)) {
  class addtocartHoverLift extends HTMLElement {
    constructor() {
      super();
      this.addtocartButtons = null;
      this.mediaItems = null;
      this.hoverTimeout = null;
    }
    
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      // 버튼 목록은 캐싱하지 않는다 — 변형 변경·퀵뷰로 갱신되므로 호버 시점에 찾는다.
      this._onOver = this.handleHoverStart.bind(this);
      this._onOut = this.handleHoverEnd.bind(this);
      document.addEventListener("mouseover", this._onOver, true);
      document.addEventListener("mouseout", this._onOut, true);
    }

    disconnectedCallback() {
      document.removeEventListener("mouseover", this._onOver, true);
      document.removeEventListener("mouseout", this._onOut, true);
      clearTimeout(this.hoverTimeout);
      clearTimeout(this.cleanupTimeout);
      this._bound = false;
    }

    // 버튼이 속한 상품 영역 안의 미디어만 고른다 — document 전역으로 잡으면
    // 퀵뷰가 열려 있을 때 뒤쪽 상품페이지 갤러리까지 같이 움직인다.
    getMediaItems(button) {
      var scope = button.closest('.popup-modal__content__data') || button.closest('.shopify-section') || document;
      return scope.querySelectorAll(".product-media__item img, .product-media__item video, .product-media__item model-viewer");
    }

    getButton(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return null;
      return target.closest(".product-form__submit.btn--addtocart-page");
    }

    handleHoverStart(event) {
      var button = this.getButton(event);
      if (!button) return;
      // 버튼 내부 이동(자식 요소 간)은 무시
      if (event.relatedTarget && button.contains(event.relatedTarget)) return;

      clearTimeout(this.hoverTimeout);
      clearTimeout(this.cleanupTimeout);
      this.mediaItems = this.getMediaItems(button);
      this.mediaItems.forEach(item => {
        item.style.transition = "transform 0.3s ease";
        item.style.transform = "translateY(-10px)";
      });
    }

    handleHoverEnd(event) {
      var button = this.getButton(event);
      if (!button) return;
      if (event.relatedTarget && button.contains(event.relatedTarget)) return;
      if (!this.mediaItems) return;

      var items = this.mediaItems;
      this.hoverTimeout = setTimeout(() => {
        // ''(빈 문자열)로 지워 인라인 선언 자체를 없앤다. "translateY(0)" 을 남기면
        // 인라인이 CSS 를 계속 이겨서 이미지에 걸린 다른 transform 이 죽는다.
        items.forEach(item => { item.style.transform = ""; });
        // 되돌아가는 전환이 끝난 뒤 transition 도 정리한다.
        this.cleanupTimeout = setTimeout(() => {
          items.forEach(item => { item.style.transition = ""; });
        }, 300);
      }, 100); // 약간의 지연을 주어 자연스러운 효과
    }
  }
  customElements.define("addtocart-hover-lift", addtocartHoverLift);
}

// 자동으로 요소 생성
document.addEventListener("DOMContentLoaded", function() {
  if (!document.querySelector("addtocart-hover-lift")) {
    const hoverLiftElement = document.createElement("addtocart-hover-lift");
    document.body.appendChild(hoverLiftElement);
  }
});
